// UMGEBUNG & ENTFERNUNGEN – Angaben laut Booking.com (ca.-Werte ab Kola Pension).
// Zentral editierbar: Gruppen, Einträge und Entfernungen hier pflegen.
import type { Localized } from "./site";

export type NearbyItem = { name: string; distance: string };
export type NearbyGroup = { title: Localized; icon: string; items: NearbyItem[] };

export const nearbyGroups: NearbyGroup[] = [
  {
    title: { de: "Was ist in der Nähe", en: "What's nearby" },
    icon: "Footprints",
    items: [
      { name: "Modellflugplatz", distance: "2,1 km" },
      { name: "Arons Hundeschule", distance: "9 km" },
      { name: "Sandstrand", distance: "10 km" },
      { name: "Spickelwiese", distance: "12 km" },
      { name: "Botanischer Garten Augsburg", distance: "12 km" },
      { name: "Heilig-Geist-Spital", distance: "13 km" },
      { name: "Naturpark Augsburg-Westliche Wälder", distance: "13 km" },
      { name: "Lechufer", distance: "13 km" },
      { name: "Ehemalige Mauthalle", distance: "13 km" },
      { name: "Zeughaus", distance: "13 km" },
    ],
  },
  {
    title: { de: "Restaurants & Cafés", en: "Restaurants & cafés" },
    icon: "UtensilsCrossed",
    items: [
      { name: "Restaurant · Goldene Hand", distance: "250 m" },
      { name: "Restaurant · Topkapi", distance: "750 m" },
      { name: "Restaurant · Mono-Loco", distance: "800 m" },
    ],
  },
  {
    title: { de: "Top-Attraktionen", en: "Top attractions" },
    icon: "Landmark",
    items: [
      { name: "Römisches Museum Augsburg", distance: "13 km" },
      { name: "Weberhaus Augsburg", distance: "14 km" },
      { name: "Rathausplatz", distance: "14 km" },
      { name: "Brechthaus", distance: "14 km" },
      { name: "Fugger Museum und Fuggerei", distance: "14 km" },
    ],
  },
  {
    title: { de: "Landschaft & Natur", en: "Landscape & nature" },
    icon: "Trees",
    items: [
      { name: "Wald · Siebentischwald", distance: "10 km" },
    ],
  },
  {
    title: { de: "Öffentlicher Nahverkehr", en: "Public transport" },
    icon: "TrainFront",
    items: [
      { name: "Bahn · Bobingen", distance: "3,6 km" },
      { name: "Bahn · Oberottmarshausen", distance: "3,6 km" },
    ],
  },
  {
    title: { de: "Nächstgelegene Flughäfen", en: "Nearest airports" },
    icon: "Plane",
    items: [
      { name: "Flughafen Augsburg", distance: "21 km" },
      { name: "Flughafen Memmingen", distance: "65 km" },
      { name: "Flughafen München", distance: "79 km" },
    ],
  },
];
